import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, WorkflowResponseDataSchema } from "schema"
import { z } from "zod"

export const getWorkflowsQueryKey = (campaignId?: string) =>
  campaignId ? ["workflows", { campaignId }] : ["workflows"]

type ListResponse = DataResponse<z.infer<typeof WorkflowResponseDataSchema>[]>

export const workflowsQuery = (campaignId?: string) =>
  queryOptions({
    queryKey: getWorkflowsQueryKey(campaignId),
    queryFn: async () => {
      const response = await axios.get<ListResponse>(`/workflows`, {
        params: campaignId ? { campaignId } : undefined,
      })
      return response.data.data
    },
  })
